module.exports = __webpack_public_path__ + "static/media/FD7.c1c422f5.png";